<template lang="pug">
  .marketing-recommend-vendor
    .marketing-recommend-vendor__scope
      category(
        v-if="showCategory"
        :data="scope"
      )
      el-row
        el-col(:span="4") {{ $t('市场部推荐供应商') }}
        el-col(:span="15")
          template(
            v-if="vendor.length !== 0"
          )
            .view-vendors-list(v-for="item in vendor")
              span {{ item.vendor_name_ch }}/{{ item.vendor_name }}
              span(v-if="item.is_storage === 0" class="non-roster") {{ $t('Non-Roster') }}
              span(v-else-if="item.is_storage === 1" class="roster") {{ $t('Roster') }}
              span(v-else-if="item.is_storage === 2" class="unregistered") {{ $t('Unregistered') }}
              span(v-else-if="item.is_storage === 3" class="unauthorised") {{ $t('Unauthorised') }}
          div(v-else) {{ $t('否') }}

      el-row
        el-col(:span="4") {{ $t('备注') }}
        el-col(:span="20")
          display-text-container(:text="remark")
</template>

<script>
import Category from '@/components/Category'
import DisplayTextContainer from '@/components/DisplayTextContainer'

export default {
  components: {
    Category,
    DisplayTextContainer
  },
  props: {
    scope: {
      type: Array,
      default () {
        return []
      }
    },
    vendor: {
      type: Array,
      default () {
        return []
      }
    },
    remark: {
      type: String,
      default () {
        return ''
      }
    },
    showCategory: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="stylus">
.marketing-recommend-vendor
  margin 30px 0
.marketing-recommend-vendor__item span
  &:first-child
    margin-right 25px
  margin-right 15px
</style>
